import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { SwitchGroupSampling } from "../../../../dynamic-forms/inputs/switch-group-sampling/switch-group-sampling.model";
import { Switch } from "../../../../dynamic-forms/inputs/switch/switch.model";

@Component({
  selector: "app-high-risk-sampling",
  templateUrl: "./high-risk-sampling.component.html",
  styleUrls: ["./high-risk-sampling.component.scss"],
})
export class HighRiskSamplingComponent {

oigGuidanceUrl = "https://oig.hhs.gov/documents/audit/9174/A-07-23-01213-Complete%20Report.pdf";

@Input() highRiskCategoryInput: SwitchGroupSampling;
@Input() highRiskCategoryEnabled: Switch;
@Input() riskFormGroup: FormGroup;

}
